/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosFeedbackRequest = {
    feedbackType: AptosFeedbackRequest.feedbackType;
    address?: string;
    suggestedLabel?: string;
    comment: string;
    url?: string;
    timestamp: number;
};

export namespace AptosFeedbackRequest {

    export enum feedbackType {
        FEATURE_REQUEST = 'FEATURE_REQUEST',
        BUG_REPORT = 'BUG_REPORT',
        SEARCH_REPORT = 'SEARCH_REPORT',
        PERFORMANCE = 'PERFORMANCE',
        SUGGEST_NEW_ADDRESS_LABEL = 'SUGGEST_NEW_ADDRESS_LABEL',
        INCORRECT_ADDRESS_LABEL = 'INCORRECT_ADDRESS_LABEL',
        OTHER = 'OTHER',
    }


}

